// automatically generated by the FlatBuffers compiler, do not modify

/**
 * @const
 * @namespace
 */
var ECGSmartTrainer = ECGSmartTrainer || {};

/**
 * @constructor
 */
ECGSmartTrainer.ECGDataArray = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {ECGSmartTrainer.ECGDataArray}
 */
ECGSmartTrainer.ECGDataArray.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {ECGSmartTrainer.ECGDataArray=} obj
 * @returns {ECGSmartTrainer.ECGDataArray}
 */
ECGSmartTrainer.ECGDataArray.getRootAsECGDataArray = function(bb, obj) {
  return (obj || new ECGSmartTrainer.ECGDataArray).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param {number} index
 * @returns {number}
 */
ECGSmartTrainer.ECGDataArray.prototype.ecgdata = function(index) {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readFloat32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};

/**
 * @returns {number}
 */
ECGSmartTrainer.ECGDataArray.prototype.ecgdataLength = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns {Float32Array}
 */
ECGSmartTrainer.ECGDataArray.prototype.ecgdataArray = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? new Float32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
ECGSmartTrainer.ECGDataArray.startECGDataArray = function(builder) {
  builder.startObject(1);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} ecgdataOffset
 */
ECGSmartTrainer.ECGDataArray.addEcgdata = function(builder, ecgdataOffset) {
  builder.addFieldOffset(0, ecgdataOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
ECGSmartTrainer.ECGDataArray.createEcgdataVector = function(builder, data) {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addFloat32(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
ECGSmartTrainer.ECGDataArray.startEcgdataVector = function(builder, numElems) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
ECGSmartTrainer.ECGDataArray.endECGDataArray = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @constructor
 */
ECGSmartTrainer.ECGDataPackage = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {ECGSmartTrainer.ECGDataPackage}
 */
ECGSmartTrainer.ECGDataPackage.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {ECGSmartTrainer.ECGDataPackage=} obj
 * @returns {ECGSmartTrainer.ECGDataPackage}
 */
ECGSmartTrainer.ECGDataPackage.getRootAsECGDataPackage = function(bb, obj) {
  return (obj || new ECGSmartTrainer.ECGDataPackage).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
ECGSmartTrainer.ECGDataPackage.prototype.id = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
ECGSmartTrainer.ECGDataPackage.prototype.sessionguid = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
ECGSmartTrainer.ECGDataPackage.prototype.leadscount = function() {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @returns {number}
 */
ECGSmartTrainer.ECGDataPackage.prototype.readingscount = function() {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
};

/**
 * @returns {number}
 */
ECGSmartTrainer.ECGDataPackage.prototype.timestamp = function() {
  var offset = this.bb.__offset(this.bb_pos, 12);
  return offset ? this.bb.readFloat64(this.bb_pos + offset) : 0.0;
};

/**
 * @returns {number}
 */
ECGSmartTrainer.ECGDataPackage.prototype.bitrate = function() {
  var offset = this.bb.__offset(this.bb_pos, 14);
  return offset ? this.bb.readUint16(this.bb_pos + offset) : 250;
};

/**
 * @param {number} index
 * @param {ECGSmartTrainer.ECGDataArray=} obj
 * @returns {ECGSmartTrainer.ECGDataArray}
 */
ECGSmartTrainer.ECGDataPackage.prototype.ecgdata = function(index, obj) {
  var offset = this.bb.__offset(this.bb_pos, 16);
  return offset ? (obj || new ECGSmartTrainer.ECGDataArray).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
};

/**
 * @returns {number}
 */
ECGSmartTrainer.ECGDataPackage.prototype.ecgdataLength = function() {
  var offset = this.bb.__offset(this.bb_pos, 16);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
ECGSmartTrainer.ECGDataPackage.startECGDataPackage = function(builder) {
  builder.startObject(7);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} id
 */
ECGSmartTrainer.ECGDataPackage.addId = function(builder, id) {
  builder.addFieldInt32(0, id, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} sessionguidOffset
 */
ECGSmartTrainer.ECGDataPackage.addSessionguid = function(builder, sessionguidOffset) {
  builder.addFieldOffset(1, sessionguidOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} leadscount
 */
ECGSmartTrainer.ECGDataPackage.addLeadscount = function(builder, leadscount) {
  builder.addFieldInt32(2, leadscount, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} readingscount
 */
ECGSmartTrainer.ECGDataPackage.addReadingscount = function(builder, readingscount) {
  builder.addFieldInt32(3, readingscount, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} timestamp
 */
ECGSmartTrainer.ECGDataPackage.addTimestamp = function(builder, timestamp) {
  builder.addFieldFloat64(4, timestamp, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} bitrate
 */
ECGSmartTrainer.ECGDataPackage.addBitrate = function(builder, bitrate) {
  builder.addFieldInt16(5, bitrate, 250);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} ecgdataOffset
 */
ECGSmartTrainer.ECGDataPackage.addEcgdata = function(builder, ecgdataOffset) {
  builder.addFieldOffset(6, ecgdataOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
ECGSmartTrainer.ECGDataPackage.createEcgdataVector = function(builder, data) {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
ECGSmartTrainer.ECGDataPackage.startEcgdataVector = function(builder, numElems) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
ECGSmartTrainer.ECGDataPackage.endECGDataPackage = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} offset
 */
ECGSmartTrainer.ECGDataPackage.finishECGDataPackageBuffer = function(builder, offset) {
  builder.finish(offset);
};

// Exports for Node.js and RequireJS
this.ECGSmartTrainer = ECGSmartTrainer;
